<template>
  <div
    v-if="isEditRestricted"
    data-testid="global-policy-message"
    class="info-block d-flex align-center mb-4 w-100"
  >
    <slot name="icon">
      <v-icon class="ml-4 mr-2" :size="24" icon="$lockXs" />
    </slot>
    <slot name="details">
      <div class="body2">{{ $t("general.settingsConfiguredByAdmin") }}</div>
    </slot>
  </div>
</template>
<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  props: {
    isEditRestricted: {
      type: Boolean,
      default: false,
    },
  },
});
</script>

<style lang="scss" scoped>
.info-block {
  background-color: rgb(var(--v-theme-indigo-instructional)) !important;
  border: 1px solid rgb(var(--v-theme-indigo-pale)) !important;
  height: 40px;
}
</style>
